// @ts-check

/*
 * Pin the document scroll to (0, 0), reset header state classes, and publish
 * the print date as a CSS custom property while the print dialog is up,
 * then restore everything.
 *
 * Why scroll/class reset: without it, scrolling far enough down before
 * printing leaves an empty band at the top of the PDF (the printer captures
 * whatever scroll-state CSS left the page in) and the page header stays in
 * its compact, scrolled-into form.
 *
 * Why --print-date / --print-url: print.css uses
 * @page { @top-right { content: var(--print-date) } } and
 * @page { @bottom-center { content: var(--print-url) } } so the date and
 * full page URL appear on every page of the PDF. Setting the variables
 * just before print and clearing them after keeps them out of the
 * document's normal cascade.
 *
 * Listeners are registered once at module load — registering per
 * custom-element instance would clobber the saved state when the toolbar is
 * rendered multiple times on the same page.
 */
let savedScroll = null;
let removedHeaderClasses = [];

window.addEventListener("beforeprint", () => {
	savedScroll = { x: window.scrollX, y: window.scrollY };
	window.scrollTo({ left: 0, top: 0, behavior: "instant" });

	// The Header's own JS toggles Header-fixed / Header-compact on scroll.
	// Removing them via scroll = 0 alone races with the print snapshot, so
	// we strip them synchronously here too.
	const header = document.querySelector(".Header");
	if (header) {
		removedHeaderClasses = ["Header-fixed", "Header-compact"].filter((cls) =>
			header.classList.contains(cls),
		);
		removedHeaderClasses.forEach((cls) => header.classList.remove(cls));
	}

	// Publish today's date and the page URL as CSS custom properties so the
	// @page margin regions can render them via content: var(--print-date)
	// and content: var(--print-url). Date format DD.MM.YYYY.
	const today = new Date().toLocaleDateString("de-DE", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
	document.documentElement.style.setProperty("--print-date", `"${today}"`);
	document.documentElement.style.setProperty(
		"--print-url",
		`"${window.location.href}"`,
	);
});

window.addEventListener("afterprint", () => {
	document.documentElement.style.removeProperty("--print-date");
	document.documentElement.style.removeProperty("--print-url");

	const header = document.querySelector(".Header");
	if (header) {
		removedHeaderClasses.forEach((cls) => header.classList.add(cls));
		removedHeaderClasses = [];
	}

	if (savedScroll) {
		window.scrollTo({
			left: savedScroll.x,
			top: savedScroll.y,
			behavior: "instant",
		});
		savedScroll = null;
	}
});

class BeckPrintArticle extends HTMLElement {
	#trigger;

	constructor() {
		super();
	}

	connectedCallback() {
		this.#trigger = this.querySelector(".js-PrintArticle-trigger");

		if (!this.#trigger) {
			return;
		}

		this.#trigger.addEventListener("click", this.#handleClick);
	}

	disconnectedCallback() {
		this.#trigger?.removeEventListener("click", this.#handleClick);
	}

	#handleClick = () => {
		window.print();
	};
}

customElements.define("beck-print-article", BeckPrintArticle);
